var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { compareAsc, parseISO } from 'date-fns';
import { styled, ThemeProvider } from 'styled-components';
import theme from '../../../landing/components/core/themes/theme';
import { Challenges } from '../../../supervizors/components/marathons/challenges';
import { useMarathons } from './api';
import { Banner } from './banner/Banner';
import { MarathonsScheduled } from './banner/MarathonsScheduled';
import { NoMarathons } from './banner/NoMarathons';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-142crrz" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  gap: 24px;\n"], ["\n  display: flex;\n  flex-flow: column;\n  gap: 24px;\n"])));
var Marathons = function (_a) {
    var groupId = _a.groupId, currentTeacherId = _a.currentTeacherId, rest = __rest(_a, ["groupId", "currentTeacherId"]);
    var _b = useMarathons(), isLoading = _b.isLoading, marathons = _b.marathons, scheduledMarathons = _b.scheduledMarathons;
    var noMarathons = !isLoading &&
        (!marathons || marathons.length === 0) &&
        !scheduledMarathons.length;
    var hasMarathons = !isLoading && (marathons === null || marathons === void 0 ? void 0 : marathons.length) > 0;
    var onlyScheduledMarathons = scheduledMarathons.length > 0 && !hasMarathons;
    var scheduledMarathonsSorted = scheduledMarathons.sort(function (a, b) {
        return compareAsc(parseISO(a.startDate), parseISO(b.startDate));
    });
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsxs(Container, __assign({}, rest, { children: [_jsx(Banner, {}, void 0), noMarathons && _jsx(NoMarathons, {}, void 0), onlyScheduledMarathons && (_jsx(MarathonsScheduled, { startDate: scheduledMarathonsSorted[0].startDate }, void 0)), hasMarathons && (_jsx(Challenges, { marathons: marathons, groupId: groupId, currentTeacherId: currentTeacherId }, void 0))] }), void 0) }), void 0));
};
export default Marathons;
var templateObject_1;
